import React, { useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Typography, Box } from '@mui/material';
import "../../styles/styles.css";

interface MapProps {
  latitude: string;
  longitude: string;
  price: number;
  draggable?: boolean;
}

const getRandomOffset = () => {
  const minOffset = 0.0027;
  const maxOffset = 0.0045;
  const offset = minOffset + Math.random() * (maxOffset - minOffset);
  return Math.random() < 0.5 ? -offset : offset;
};

const PropertyMap: React.FC<MapProps> = ({ latitude, longitude, price, draggable = false }) => {
  const initialLat = parseFloat(latitude) + getRandomOffset();
  const initialLng = parseFloat(longitude) + getRandomOffset();

  const [position, setPosition] = useState<[number, number]>([initialLat, initialLng]);

  // 🔹 Ícono más grande y con clase personalizada
  const propertyIcon = new L.Icon({
    iconUrl: '/assets/images/alien.png',
    iconSize: [32, 32], 
    iconAnchor: [16, 32], 
    popupAnchor: [0, -32],
    className: 'property-icon'   
  });

  return (
    <>
      <MapContainer
        center={position}
        zoom={13}
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='Map data © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        <Marker
          position={position}
          icon={propertyIcon}
          draggable={draggable}
          eventHandlers={draggable ? {
            dragend: (e) => {
              const marker = e.target;
              const newPosition = marker.getLatLng();
              setPosition([newPosition.lat, newPosition.lng]);
            },
          } : {}}
        >
          <Popup>
            <Typography variant="button" sx={{ fontWeight: 'bold' }}>
              ₡{price.toLocaleString('es-CR')}
            </Typography>
          </Popup>
        </Marker>
      </MapContainer>

      <Box
        sx={{
          height: "100px",
          display: { xs: "block", sm: "none" },
          width: "100%",
        }}
      />
    </>
  );
};

export default PropertyMap;
